import {feature} from "topojson-client";
import moment from 'moment-timezone';

export const slugifyFireName = fireName => {
  return fireName.split(' ').join('-').toLowerCase().replace('-fire', '');
};

export const decodeTopojsonFeatures = (topojson, name) => {
    return feature(topojson, topojson.objects[name]);
}

export const setLastUpdatedTimeSince = timestamps => {
    const times = Object.values(timestamps);
    const latestTime = times.map(time => {
        return moment.utc(time).local();
    })
  
    const sorted = latestTime.sort((a, b) => a.diff(b)).pop()

    // Stick it on the page
    const el = document.getElementById('dt');
    el.innerHTML = `Last updated ${sorted.from(moment())}`;
    //el.innerHTML = `Last updated ${latestTime}`;
}

export const setCopyrightYear = d => {
    // Get the current year
    const currentYear = new Date().getFullYear();
    // Load it in the page
    const el = document.getElementById('current-year');
    el.innerHTML = currentYear;
}

export const capitalize = d =>{
  return d.charAt(0).toUpperCase() + d.slice(1);
}

export const parseParams = params => {
  let paramDict = {};
  params.split('&').forEach(p => {
    paramDict[p.split('=')[0]] = p.split('=')[1]
  });
  return paramDict;
}
